import React, { useState } from "react";
import { X, Eye, EyeOff, Loader2 } from "lucide-react";
import api from "../../api";
import { toast } from "../../hooks/use-toast";

export const ResetPasswordDialog = ({ biz, onClose }) => {
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [show, setShow] = useState(false);
  const [saving, setSaving] = useState(false);
  const mismatch = confirm && pw !== confirm;

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8 || pw !== confirm) return;
    setSaving(true);
    try {
      const { data } = await api.post(`/admin/businesses/${biz.id}/password`, { new_password: pw });
      toast({ title: "Password updated", description: `New password set for ${data.email}. No email was sent.` });
      onClose();
    } catch (err) {
      toast({ title: "Could not reset password", description: err?.response?.data?.detail || "Try again", variant: "destructive" });
    } finally { setSaving(false); }
  };

  const input = "w-full rounded-xl border border-gray-200 px-4 py-2.5 outline-none focus:border-[#2ec9c9]";
  return (
    <div className="fixed inset-0 z-[90] bg-black/50 flex items-center justify-center p-4" onClick={onClose}>
      <form onSubmit={submit} onClick={(e) => e.stopPropagation()} className="bg-white rounded-2xl w-full max-w-[420px] p-6 space-y-3" data-testid="reset-password-dialog">
        <div className="flex items-center justify-between">
          <h3 className="font-semibold text-[#16243b]">Reset password · {biz.name}</h3>
          <button type="button" onClick={onClose} data-testid="reset-password-close"><X size={18} className="text-[#5a6b80]" /></button>
        </div>
        <p className="text-xs text-[#8a97a8]">Sets a new login password for this business owner. No email is sent — pass it on yourself.</p>
        <div className="relative">
          <input type={show ? "text" : "password"} value={pw} onChange={(e) => setPw(e.target.value)} placeholder="New password (min 8 characters)" autoComplete="new-password" data-testid="reset-password-input" className={`${input} pr-10`} />
          <button type="button" onClick={() => setShow(!show)} className="absolute right-3 top-1/2 -translate-y-1/2 text-[#8a97a8]" aria-label="Show password">{show ? <EyeOff size={16} /> : <Eye size={16} />}</button>
        </div>
        <input type={show ? "text" : "password"} value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Confirm new password" autoComplete="new-password" data-testid="reset-password-confirm" className={input} />
        {mismatch && <p className="text-xs text-red-500" data-testid="reset-password-mismatch">Passwords don't match</p>}
        <button disabled={saving || pw.length < 8 || pw !== confirm} data-testid="reset-password-submit" className="gp-btn-teal w-full rounded-xl py-3 font-medium flex items-center justify-center gap-2 disabled:opacity-50">
          {saving && <Loader2 size={16} className="animate-spin" />} Set new password
        </button>
      </form>
    </div>
  );
};
